import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Выгрузка списка РПП в Excel",
    "confirm-button-text": "Выгрузить",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.exportRPP
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        type: "date",
        placeholder: "Дата от",
        value: _ctx.state.from_date,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.from_date) = $event)),
        "is-invalid": _ctx.state_form$.from_date.$error,
        "validation-errors": _ctx.state_form$.from_date.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"]),
      _createVNode(_component_the_input, {
        class: "mt-3",
        type: "date",
        placeholder: "Дата до",
        value: _ctx.state.to_date,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.to_date) = $event)),
        "is-invalid": _ctx.state_form$.to_date.$error,
        "validation-errors": _ctx.state_form$.to_date.$errors
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}